import React from 'react'
// import technical from './technicalData'
// import TimelineItem from './TimelineComponent'
// import './timeline.css'
import { Box, Heading, Text } from '@chakra-ui/react'
import technical from './technicalData';
import cultural from './Culturaldata';
import literary from './Literarydata';
import finearts from './Fineartsdata';
import Sher from "./images/lion.gif";
import Marquee from "react-fast-marquee";

const TechnicalTimeline = () => {
    return (
        <Box>
            <Box style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                flexDirection: 'column',
                flexWrap: 'wrap',
                margin: '10px',
                padding: '10px',
            }}>

                <Heading as="h1" size='xl' color={'blue.600'}>TECHNICAL EVENTS</Heading>
                <br />
                <Box style={{
                    display: 'flex',
                    justifyContent: 'center',
                    // flexDirection: 'column',
                    flexWrap: 'wrap',
                }}>
                    {technical.map((item, index) => (
                        <Box key={index} style={{
                            width: '300px',
                            border: '1px solid grey',
                            padding: '10px',
                        }}>
                            <Heading as='h5' size='md'>{item.title}</Heading>
                            <Text as='samp' size='xs'>{item.date}</Text>
                            <Text as='h6' size='xs'>{item.timing}</Text>
                            <Text as='h6' size='xs'>{item.venue}</Text>
                        </Box>
                    ))}
                </Box>
            </Box>
            <br />
            <Box style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                flexDirection: 'column',
                flexWrap: 'wrap',
                margin: '10px',
                padding: '10px',
            }}>
                <Heading as="h1" size='xl' color={'blue.600'}>CULTURAL EVENTS</Heading>
                <br />
                <Box style={{
                    display: 'flex',
                    justifyContent: 'center',
                    // flexDirection: 'column',
                    flexWrap: 'wrap',
                }}>
                    {cultural.map((item, index) => (
                        <Box key={index} style={{
                            width: '300px',
                            border: '1px solid grey',
                            padding: '10px',
                        }}>
                            <Heading as='h5' size='md'>{item.title}</Heading>
                            <Text as='samp' size='xs'>{item.date}</Text>
                            <Text as='h6' size='xs'>{item.timing}</Text>
                            <Text as='h6' size='xs'>{item.venue}</Text>
                        </Box>
                    ))}
                </Box>
            </Box>
            <br />
            <Box style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                flexDirection: 'column',
                flexWrap: 'wrap',
                margin: '10px',
                padding: '10px',
            }}>
                <Heading as="h1" size='xl' color={'blue.600'}>LITERARY EVENTS</Heading>
                <br />
                <Box style={{
                    display: 'flex',
                    justifyContent: 'center',
                    // flexDirection: 'column',
                    flexWrap: 'wrap',
                }}>
                    {literary.map((item, index) => (
                        <Box key={index} style={{
                            width: '300px',
                            border: '1px solid grey',
                            padding: '10px',
                        }}>
                            <Heading as='h5' size='md'>{item.title}</Heading>
                            <Text as='samp' size='xs'>{item.date}</Text>
                            <Text as='h6' size='xs'>{item.timing}</Text>
                            <Text as='h6' size='xs'>{item.venue}</Text>
                        </Box>
                    ))}
                </Box>
            </Box>
            <br />
            <Box style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                flexDirection: 'column',
                flexWrap: 'wrap',
                margin: '10px',
                padding: '10px',
            }}>
                <Heading as="h1" size='xl' color={'blue.600'}>FINE ARTS &amp; PHOTOGRAPHY EVENTS</Heading>
                <br />
                <Box style={{
                    display: 'flex',
                    justifyContent: 'center',
                    // flexDirection: 'column',
                    flexWrap: 'wrap',
                }}>
                    {finearts.map((item, index) => (
                        <Box key={index} style={{
                            width: '300px',
                            border: '1px solid grey',
                            padding: '10px',
                        }}>
                            <Heading as='h5' size='md'>{item.title}</Heading>
                            <Text as='samp' size='xs'>{item.date}</Text>
                            <Text as='h6' size='xs'>{item.timing}</Text>
                            <Text as='h6' size='xs'>{item.venue}</Text>
                        </Box>
                    ))}
                </Box>
            </Box>
            <Marquee
                speed={80}
                pauseOnClick={true}
                gradient={false}
                style={{
                    position: "sticky",
                    bottom: "0",
                    // top: "0px",
                    color: "Red",
                    fontWeight: "bold",
                    height: "40px",
                    background: "#34F5C5",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    flexDirection: "row",
                    letterSpacing: "3px",
                }}
            >
                <img
                    src={Sher}
                    alt="Lion GIF"
                    style={{ width: "80px", display: "inline" }}
                />
                &nbsp; **Students must bring Identity Card with them at the time of Entry** &nbsp;
                <img
                    src={Sher}
                    alt="Lion GIF"
                    style={{ width: "80px", display: "inline" }}
                />
            </Marquee>
        </Box>

    )
}

export default TechnicalTimeline